import { ErrorBuilder, SchemaErrors } from 'src/utils/validation';
import { CbamInstallationInSchema } from '../types';
import { TFunction } from 'react-i18next';

export type FormErrors = SchemaErrors<CbamInstallationInSchema>;

export const requiredFields: (keyof CbamInstallationInSchema)[] = [
  'identifier',
  'name',
  'country',
  'operator_id',
];

export const validateForm = (
  data: CbamInstallationInSchema,
  t: TFunction
): FormErrors => {
  const builder = new ErrorBuilder(data);
  return builder.checkTruthy(requiredFields, t('validation.required')).build();
};
